<template>
  <div class="action-confirmation-container">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h3 class="title has-text-white has-text-centered">Desfazer ação</h3>
          <div class="box custom-box">
            <div class="message-container has-text-left">
              <b-icon
                class="custom-icon"
                icon="alert-box"
                size="is-large"
                type="is-warning"
              ></b-icon>
              <div class="message-warning-container">
                <div class="warning-text">
                  {{ warningText }}
                </div>
              </div>
            </div>

            <div class="undo-scrollable-content">
              <div v-if="items.length" class="undo-impact-list">
                <p class="has-text-weight-semibold">Impactos do desfazer:</p>
                <div
                  v-for="item in items"
                  :key="`impact-${item.itemId || item.identifier}`"
                  class="undo-impact-item"
                >
                  <p class="has-text-weight-semibold">
                    Item {{ item.identifier
                    }}<span v-if="item.description"> — {{ item.description }}</span>
                  </p>
                  <p v-if="item.actionLabel" class="undo-impact-action">
                    <template v-if="item.bidderAlias">
                      Ação atual: {{ getActionLabelWithoutContext(item.actionLabel) }} do Fornecedor
                      <strong>{{
                        formatBidderDisplay(
                          item.bidderAlias,
                          item.bidderSocialDenomination,
                          isJudgmentUndo(item),
                        )
                      }}</strong
                      >{{ getActionContextSuffix(item.actionLabel) }}
                    </template>
                    <template v-else> Ação atual: {{ item.actionLabel }} </template>
                  </p>
                  <div v-if="item.cascadeActions && item.cascadeActions.length">
                    <p class="has-text-weight-semibold">Também será desfeito:</p>
                    <ul>
                      <li
                        v-for="(cascade, index) in item.cascadeActions"
                        :key="`cascade-${item.itemId || item.identifier}-${index}`"
                      >
                        <template
                          v-if="
                            cascade.kind === 'HABILITACAO_POSTERIOR' &&
                            (cascade.bidderAlias || item.bidderAlias)
                          "
                        >
                          {{ cascade.operationLabel || 'Habilitação' }} do Fornecedor
                          <strong>{{
                            formatBidderDisplay(
                              cascade.bidderAlias || item.bidderAlias,
                              cascade.bidderSocialDenomination || item.bidderSocialDenomination,
                              isJudgmentUndo(item),
                            )
                          }}</strong>
                          vinculada ao item
                        </template>
                        <template
                          v-else-if="
                            cascade.kind === 'ADESAO_HABILITACAO_POSTERIOR' &&
                            (cascade.bidderAlias || item.bidderAlias)
                          "
                        >
                          {{ cascade.operationLabel || 'Habilitação de Adesão' }} do Fornecedor
                          <strong>{{
                            formatBidderDisplay(
                              cascade.bidderAlias || item.bidderAlias,
                              cascade.bidderSocialDenomination || item.bidderSocialDenomination,
                              isJudgmentUndo(item),
                            )
                          }}</strong>
                          vinculada ao item
                        </template>
                        <template
                          v-else-if="
                            cascade.kind === 'ADESAO_POSTERIOR' &&
                            (cascade.bidderAlias || item.bidderAlias)
                          "
                        >
                          Adesão do lance do Fornecedor
                          <strong>{{
                            formatBidderDisplay(
                              cascade.bidderAlias || item.bidderAlias,
                              cascade.bidderSocialDenomination || item.bidderSocialDenomination,
                              isJudgmentUndo(item),
                            )
                          }}</strong>
                          será removida
                        </template>
                        <template
                          v-else-if="
                            cascade.kind === 'ACEITABILIDADE_POSTERIOR' &&
                            (cascade.bidderAlias || item.bidderAlias)
                          "
                        >
                          Registros posteriores de aceitabilidade do Fornecedor
                          <strong>{{
                            formatBidderDisplay(
                              cascade.bidderAlias || item.bidderAlias,
                              cascade.bidderSocialDenomination || item.bidderSocialDenomination,
                              isJudgmentUndo(item),
                            )
                          }}</strong>
                          serão preservados
                        </template>
                        <template
                          v-else-if="
                            cascade.kind === 'CLASSIFICACAO_POSTERIOR' &&
                            (cascade.bidderAlias || item.bidderAlias)
                          "
                        >
                          {{ cascade.operationLabel || 'Classificação' }} do Fornecedor
                          <strong>{{
                            formatBidderDisplay(
                              cascade.bidderAlias || item.bidderAlias,
                              cascade.bidderSocialDenomination || item.bidderSocialDenomination,
                              false,
                            )
                          }}</strong>
                          na Análise de Propostas
                        </template>
                        <template v-else>
                          {{ cascade.label }}
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div v-if="ineligibleItems.length" class="ineligible-warning">
                <p class="has-text-weight-semibold has-text-danger">
                  Os itens abaixo não serão desfeitos:
                </p>
                <ul>
                  <li v-for="item in ineligibleItems" :key="item.itemId || item.identifier">
                    Item {{ item.identifier
                    }}<span v-if="item.description"> — {{ item.description }}</span
                    ><span v-if="item.reason"> — {{ item.reason }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="undo-fixed-footer">
              <b-field
                class="custom-justification-field"
                label="Justificativa"
                :type="campoInvalido('justificativa', 'data') ? 'is-danger' : ''"
                :message="
                  campoInvalido('justificativa', 'data')
                    ? 'Justificativa é um campo obrigatório'
                    : ''
                "
              >
                <b-input
                  type="textarea"
                  class="custom-textarea"
                  ref="justificativa"
                  rows="3"
                  maxlength="2000"
                  placeholder="Justifique o desfazimento da ação."
                  v-model="data.justificativa"
                />
              </b-field>

              <div class="footer-container">
                <div class="buttons-container has-text-right">
                  <b-button
                    class="rm-1"
                    :size="mobile ? 'is-small' : 'is-normal'"
                    :disabled="loading"
                    @click.stop.prevent="closeModal()"
                  >
                    Cancelar
                  </b-button>

                  <b-button
                    ref="confirm"
                    class="is-outlined"
                    type="is-danger"
                    :size="mobile ? 'is-small' : 'is-normal'"
                    :loading="loading"
                    @click.stop.prevent="sendConfirmation"
                  >
                    Desfazer
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

import fieldMixin from '@/mixins/formulario';

export default {
  name: 'AppUndoConfirmation',
  mixins: [fieldMixin],
  props: {
    ineligibleItems: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
    warningText: {
      type: String,
      default:
        'Esta ação irá desfazer a última decisão operacional desfazível dos itens selecionados na etapa atual.',
    },
  },
  data() {
    return {
      data: {
        justificativa: '',
      },
    };
  },
  validations: {
    data: {
      justificativa: {
        required,
      },
    },
  },
  methods: {
    isJudgmentUndo(item) {
      const actionLabel = item?.actionLabel || '';
      return /julgamento/i.test(actionLabel);
    },
    formatBidderDisplay(alias, socialDenomination, isJudgment) {
      if (!alias) return '';
      if (isJudgment || !socialDenomination) return alias;
      return `${alias} - ${socialDenomination}`;
    },
    getActionLabelWithoutContext(actionLabel) {
      if (!actionLabel) return '';
      return actionLabel.replace(/\s+no Julgamento$/i, '').trim();
    },
    getActionContextSuffix(actionLabel) {
      if (!actionLabel) return '';
      return /\s+no Julgamento$/i.test(actionLabel) ? ' no Julgamento' : '';
    },
    closeModal() {
      this.$parent.onCancel();
      this.$parent.close();
    },
    sendConfirmation() {
      if (!this.data.justificativa?.trim()) {
        this.$v.data.$touch();
        return;
      }

      this.$parent.$emit('confirm', { justificativa: this.data.justificativa.trim() });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.justificativa.focus();
    });
  },
};
</script>

<style lang="scss" scoped>
.action-confirmation-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 100vh;
  overflow: hidden;
  width: 100%;

  .hero.is-fullheight {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    min-height: 0;
  }

  .hero-body {
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 1;
    max-height: 100vh;
    min-height: 0;
    overflow: hidden;
    padding: 1.5rem;
  }

  .container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    min-height: 0;
    overflow: hidden;
    width: 100%;
  }

  .title {
    flex-shrink: 0;
    margin-bottom: 1rem;
  }
}

.buttons-container {
  margin-top: 0.75rem;
}

.custom-box {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 7rem);
  min-height: 0;
  overflow: hidden;
}

.custom-icon {
  margin-right: 0.5rem;
}

.custom-justification-field {
  margin-bottom: 0;
  margin-top: 0;
}

.custom-textarea {
  width: 100%;
}

.footer-container {
  margin-top: 0.25rem;
}

.ineligible-warning {
  font-size: 0.88rem;
  margin-top: 1rem;

  ul {
    margin-left: 1rem;
    margin-top: 0.5rem;
  }
}

.undo-scrollable-content {
  flex: 1 1 auto;
  margin-top: 0.5rem;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.undo-fixed-footer {
  flex-shrink: 0;
  margin-top: 0.75rem;
  padding-top: 0.25rem;
}

.undo-impact-list {
  font-size: 0.88rem;
}

.undo-impact-item {
  border-top: 1px solid #e9e9e9;
  margin-top: 0.5rem;
  padding-top: 0.5rem;

  &:first-of-type {
    border-top: none;
    margin-top: 0.5rem;
    padding-top: 0;
  }
}

.undo-impact-action {
  margin: 0.25rem 0;
}

.undo-impact-subtitle {
  margin-top: 0.25rem;
}

.message-container {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-bottom: 0.25rem;
}

.rm-1 {
  margin-right: 3px;
}

.warning-text {
  margin-bottom: 0.5rem;
}

@media (max-height: 700px) {
  .action-confirmation-container {
    .hero-body {
      padding: 0.75rem 1rem;
    }

    .title {
      font-size: 1.35rem;
      margin-bottom: 0.5rem;
    }
  }

  .undo-fixed-footer {
    margin-top: 0.5rem;
  }

  .buttons-container {
    margin-top: 0.5rem;
  }
}
</style>
